import { render } from "./TermsScreen.vue?vue&type=template&id=0231725f&scoped=true"
import script from "./TermsScreen.vue?vue&type=script&lang=js"
export * from "./TermsScreen.vue?vue&type=script&lang=js"

import "./TermsScreen.vue?vue&type=style&index=0&id=0231725f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0231725f"]])

export default __exports__